// extracted by mini-css-extract-plugin
export default {"frame":"Frame-module__frame-VNl6","fadeIn":"Frame-module__fadeIn-K1qV","card":"Frame-module__card-tGF2"};